import requests from '@/utils/requests';

/**
 * 创建业务域
 * @param {*} data
 */
export function domainAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/domain/add',
    method: 'post',
    data
  });
}

/**
 * 业务域列表
 * @param {*} data
 */
export function domainList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/domain/list',
    method: 'post',
    data
  });
}

/**
 * 业务域基础信息列表
 * @param {*} data
 */
export function domainBasicList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/domain/basicList',
    method: 'post',
    data
  });
}

/**
 * 修改业务域
 * @param {*} data
 */
export function domainModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/domain/modify',
    method: 'post',
    data
  });
}

/**
 * 删除业务域
 * @param {*} data
 */
export function domainDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/domain/delete',
    method: 'post',
    data
  });
}
